<template>
  <SearchForm
    :baseApiUrl="baseApiUrl"
    :searchPage="searchPage"
    :texts="texts"
    :suggestSokOptions="suggestSokOptions"
    :idString="'headerSearch'"
    :selectedFilter="''"
    :sokFilter="[]"
  ></SearchForm>
</template>

<script>
import SearchForm from "./components/searchform.vue";

export default {
  name: "HeaderSearch",
  props: {
    baseApiUrl: String,
    searchPage: String,
    queryString: String,
    texts: Object,
    suggestSokOptions: Object,
  },
  components: {
    SearchForm,
  },
};
</script>
